<template>
  <div class="align-center">
    <div
      v-text="visibleText"
      class="animated-text"
      :class="{
        active: started && !stopped,
        test: subTitleFont,
        'animated-text-mobile': !device,
      }"
    ></div>
    <!-- <hr v-if="!subTitleFont" class="hr-line" /> -->
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    duration: {
      type: Number,
      default: 2000,
    },
    delay: {
      type: Number,
      default: 500,
    },
    stopAfter: {
      type: Number,
      default: 2000,
    },
    subTitleFont: {
      type: Boolean,
      default: true,
    },
    device: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visibleIndex: -1,
      started: false,
      stopped: false,
      animationId: null,
    };
  },
  computed: {
    visibleText() {
      return this.text.slice(0, this.visibleIndex + 1);
    },
  },
  methods: {
    resetAnimation() {
      this.visibleIndex = -1;
      this.started = false;
      this.stopped = false;
    },
    startAnimation() {
      let length = this.text.length,
        timeout = parseInt(this.duration) / length;

      this.started = true;
      let animationId = Math.floor(Math.random() * 10 ** 6); // 6-digits random id for animation
      this.animationId = animationId;

      for (let index = 0; index < length; index++) {
        let currentTimeout = Math.round((index + 1) * timeout);

        window.setTimeout(() => {
          if (this.animationId === animationId) {
            // if this animation is current animation (fix bug of two animations at same time)
            this.visibleIndex = index;

            if (index === length - 1) {
              this.$emit("done");
              window.setTimeout(() => {
                this.stopped = true;
              }, this.stopAfter);
            }
          }
        }, currentTimeout);
      }
    },
  },
  watch: {
    text() {
      this.resetAnimation();
      this.startAnimation();
    },
  },
  mounted() {
    let delay = parseInt(this.delay);
    if (delay) {
      window.setTimeout(() => {
        this.startAnimation();
      }, delay);
    } else {
      this.startAnimation();
    }
  },
};
</script>

<style lang="scss" scoped>
.animated-text {
  position: relative;
  width: 70%;
  left: 10%;
  top: 20%;
  // background-color: rgb(0, 0, 0); /* Fallback color */
  // background-color: rgba(0, 0, 0, 0.4); /* Black w/opacity/see-through */
  color: rgb(0, 0, 0);
  z-index: 2;

  font-family: Poppins;
  font-size: 64px;
  font-weight: 500;
  line-height: 82px;
  letter-spacing: 0em;
  text-align: left;

  &.active {
    &:after {
      content: "|";
      font-weight: 700;
      animation: fade 0.8s linear infinite;
    }
  }
  @keyframes fade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.1;
    }
    100% {
      opacity: 1;
    }
  }
}
.animated-text-mobile {
  position: relative;
  width: 75%;
  color: rgb(0, 0, 0);
  z-index: 2;

  font-family: Poppins;
  font-size: 36px;
  font-weight: 500;
  line-height: 52px;
  letter-spacing: 0em;
  text-align: left;

  &.active {
    &:after {
      content: "|";
      font-weight: 700;
      animation: fade 0.8s linear infinite;
    }
  }
  @keyframes fade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.1;
    }
    100% {
      opacity: 1;
    }
  }
}
.test {
  font-family: Roboto;
  font-size: 22px;
  font-weight: 500;
  line-height: 35px;
  letter-spacing: 0em;
  text-align: left;
  left: 10%;
}
.hr-line {
  position: absolute;
  background: #333333;
  border: 1px solid #02173a;
  border-radius: 0px;
  width: 75px;
  height: 3px;
  left: 25%;
}
</style>
